import { PlusIcon } from '@/icons';
import { IconButton } from '@/ui_v3';
export const FileOverIndicator = () => {
  return <IconButton className="size-fit" size="md" variant={'contained'} intent="strong" data-sentry-element="IconButton" data-sentry-component="FileOverIndicator" data-sentry-source-file="FileOverIndicator.tsx">
      <PlusIcon size="md" data-sentry-element="PlusIcon" data-sentry-source-file="FileOverIndicator.tsx" />
    </IconButton>;
};